<template>
  <div>
    <div>
      <router-link to="/">Home</router-link>
      <label class="labelBar"> / </label>
      <label> Cadastro/Mecanico</label>
    </div>
    <tab-navegacao :active_tab="active_tab" />
    <v-container fluid
      ><v-row align="center">
        <v-col>
          <v-btn
            color="info"
            to="/mecanico/criar"
            v-if="isAllowed(1)"
            class="ma-2 white--text"
          >
            NOVO
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-checkbox
            v-if="mecanicos.length > 0"
            v-model="showAtivo"
            label="MOSTRAR ITENS INATIVOS"
          ></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn
            @click="baixarlista()"
            v-if="mecanicos.length > 0"
            class="ma-2 blue--text"
            align="right"
          >
            <v-icon>mdi-file-excel</v-icon>
            Baixar planilha
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="filteredList"
        :loading="loading"
        loading-text="Buscando dados..."
        :search="search"
        :footer-props="{
          showFirstLastPage: true,
          itemsPerPageText: 'Items por página',
          itemsPerPageOptions: [5, 10, 15, -1],
        }"
      >
        <template v-slot:item.ativo="{ item }">
          {{ item.ativo ? "Ativo" : "Inativo" }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                class="mr-2"
                @click="editar(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span v-if="isAllowed(1)">Editar</span>
            <span v-else>Ver</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { downloadLista } from "../../../services/mecanicoService";
import { getUserRoles } from "@/services/loginService";

export default {
  name: "listamecanicos",
  data() {
    return {
      loading: false,
      search: "",
      showAtivo: false,
      active_tab: 2,
      headers: [
        {
          text: "Id", align: "start", value: "id",
        },
        { text: "Mecanico", value: "nome" },
        { text: "Cargo", value: "cargo" },
        { text: "Status", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false },
      ],
      filters: {
        nome: [],
      },
    };
  },
  computed: {
    ...mapState("mecanico", ["mecanicos"]),
    ...mapState("cargo", ["cargos"]),
    filteredList() {
      if (this.showAtivo === false) {
        var newList = this.mecanicos.filter((m) => {
          return (
            m.nome.toLowerCase().includes(this.search.toLowerCase()) &&
            m.ativo === true
          );
        });
        return newList.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      } else {
        var novaLista = this.mecanicos.filter((m) => {
          return m.nome.toLowerCase().includes(this.search.toLowerCase());
        });
        return novaLista.filter((d) => {
          return Object.keys(this.filters).every((f) => {
            return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
          });
        }).sort( function ( a, b ) { return b.id - a.id; } );
      }
    },
  },
  methods: {
    ...mapActions("mecanico", ["atualizarMecanico", "atualizarMecanicos"]),
    ...mapActions("cargo", ["atualizarCargos"]),
    editar(mecanico) {
      this.atualizarMecanico(mecanico);
      if (this.isAllowed(1)) {
        this.$router.push(`/mecanico/editar`);
      } else {
        this.$router.push(`/mecanico/ver`);
      }
    },
    baixarlista() {
      //downloadLista();
    },
    async obterLista() {
      this.loading = true;
      await this.atualizarMecanicos();
      this.loading = false;
    },
    async doAjax() {
      if (!this.cargos || this.cargos.length == 0) {
        this.atualizarCargos();
      }
    },
    isAllowed(id) {
      var regra = this.regras.find((r) => {
        return r.idModulo == id;
      });
      return regra != null && regra.escrita;
    },
    columnValueList(val) {
      return this.filteredList.map((d) => d[val]);
    },
  },
  created: function () {
    this.doAjax();
    this.obterLista();
    var roles = getUserRoles();
    if (roles) {
      this.regras = roles;
    }
  },
};
</script>
